import { get } from "../index";

// Worker dashboard API. The worker wraps responses as { success, data, timestamp };
// these helpers unwrap to .data for convenience.
const unwrap = (p) =>
  p.then((r) => (r && Object.prototype.hasOwnProperty.call(r, "data") ? r.data : r));

export const getWorkerHealth = () => unwrap(get(`/worker/api/health/detailed`));
export const getWorkerSummary = () => get(`/worker/api/health`);
export const getWorkerThroughputSummary = () =>
  unwrap(get(`/worker/api/throughput/summary`));
export const getWorkerThroughputRealtime = () =>
  unwrap(get(`/worker/api/throughput/realtime`));
export const getWorkerOutboxStats = () => unwrap(get(`/worker/api/outbox/stats`));
export const listOutbox = (status = "pending", limit = 50) =>
  unwrap(get(`/worker/api/outbox?status=${status}&limit=${limit}`));
export const retryOutbox = (id) =>
  fetch(`/worker/api/outbox/retry/${id}`, { method: "POST" });
